import type { UserSource, UserSourceBindingType } from "../types";

export type UserSourcesByBinding = Record<UserSourceBindingType, UserSource[]>;

export function groupUserSourcesByBinding(
  items: UserSource[]
): UserSourcesByBinding {
  return {
    project: items.filter((item) => item.binding_type === "project"),
    organization: items.filter((item) => item.binding_type === "organization"),
  };
}
